"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fit = exports.toClickOutside = exports.getWindowSize = exports.getElementSize = exports.useTooltip = exports.directionAlias = exports.padding = void 0;
const react_1 = require("react");
const tooltip_types_1 = require("./tooltip.types");
const directions = [
    tooltip_types_1.TooltipDirection.UP,
    tooltip_types_1.TooltipDirection.RIGHT,
    tooltip_types_1.TooltipDirection.DOWN,
    tooltip_types_1.TooltipDirection.LEFT,
];
exports.padding = 11;
exports.directionAlias = {
    [tooltip_types_1.TooltipDirection.UP]: tooltip_types_1.PopperDirection.TOP,
    [tooltip_types_1.TooltipDirection.DOWN]: tooltip_types_1.PopperDirection.BOTTOM,
    [tooltip_types_1.TooltipDirection.LEFT]: tooltip_types_1.PopperDirection.LEFT,
    [tooltip_types_1.TooltipDirection.RIGHT]: tooltip_types_1.PopperDirection.RIGHT,
};
function useTooltip() {
    const controls = (0, react_1.useRef)(new Set([]));
    const container = (0, react_1.useRef)(null);
    const registerControl = (0, react_1.useCallback)((el) => el && controls.current.add(el), []);
    return {
        to: controls,
        container,
        registerControl,
    };
}
exports.useTooltip = useTooltip;
function getElementSize($element) {
    const { top, right, bottom, left } = $element.getBoundingClientRect();
    return {
        top,
        right,
        bottom,
        left,
        width: right - left,
        height: bottom - top,
    };
}
exports.getElementSize = getElementSize;
function getWindowSize() {
    return {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
exports.getWindowSize = getWindowSize;
function toClickOutside(popper) {
    var _a;
    return [{ current: (_a = popper.current) === null || _a === void 0 ? void 0 : _a.state.elements.reference }];
}
exports.toClickOutside = toClickOutside;
function fit({ $container, $control, $tooltip, direction, }) {
    const box = $container ? getElementSize($container) : getWindowSize();
    const origin = getElementSize(document.body);
    const control = getElementSize($control);
    const tooltip = getElementSize($tooltip);
    const cleft = control.left - origin.left;
    const cright = control.right - origin.left;
    const ctop = control.top - origin.top;
    const cbottom = control.bottom - origin.top;
    const xmin = box.left - origin.left;
    const xmax = box.right - origin.left;
    const ymin = box.top - origin.top;
    const ymax = box.bottom - origin.top;
    const controlWithin = ctop - ymin >= 0 && ymax - cbottom >= 0;
    const possibleDirections = {
        left: controlWithin && cleft - exports.padding - tooltip.width >= xmin,
        right: controlWithin && cright + exports.padding + tooltip.width <= xmax,
        up: ctop - exports.padding - tooltip.height >= ymin,
        down: cbottom + exports.padding + tooltip.height <= ymax,
    };
    const realDirection = [
        ...directions.slice(directions.indexOf(direction)),
        ...directions.slice(0, directions.indexOf(direction)),
    ].find((dir) => possibleDirections[dir]) || direction;
    return exports.directionAlias[realDirection];
}
exports.fit = fit;
